import { DatePicker, TimePicker, type TimePickerProps } from 'antd'
import type { Dayjs } from 'dayjs'
import { dayjsWithTimezone, getFixedZoneTime } from '@/utils/intl/dateTimeFormatters'

interface TimezoneDateTimePickerProps extends Omit<TimePickerProps, 'onChange'> {
  onChange?: (value: Dayjs) => void
  timezone: string
  picker: 'time' | 'date'
}

export function TimezoneDateTimePicker({ timezone, value, onChange, picker, ...rest }: TimezoneDateTimePickerProps) {
  const displayValue: Dayjs | null = value ? dayjsWithTimezone(value, timezone) : null
  const handleChange = (changed: Dayjs) => {
    // weird sad hack that prevents time from getting adjusted on first change
    const isCorrectTimezone = changed.$x?.$timezone === timezone
    const value = isCorrectTimezone ? changed : getFixedZoneTime(changed, timezone)
    onChange?.(value)
  }
  return picker === 'date' ? (
    <DatePicker value={displayValue} onChange={handleChange} {...rest} />
  ) : (
    <TimePicker value={displayValue} onChange={handleChange} format='HH:mm' {...rest} />
  )
}
